import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MwebPayPage } from './mweb-pay';

@NgModule({
  declarations: [
    MwebPayPage,
  ],
  imports: [
    IonicPageModule.forChild(MwebPayPage),
  ],
})
export class MwebPayPageModule {}



// WEBPACK FOOTER //
// ./src/pages/mweb-pay/mweb-pay.module.ts